@import "~animatewithsass/animate.scss";
@mixin button {
  .btn {
    outline: none !important;
    box-shadow: none;
    padding: 6px 10px 6px 10px;
    font-size: 15px !important;
    font-weight: 100;
  }
}
.switch {
  .block1{
    border-radius: 12px;
    @include button;
    .btn-custom{
      box-shadow: none;
      padding: 6px 10px 6px 10px;
    }
    .btn-on{
      padding-right: 10px !important;
      padding-left: 10px !important;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    .btn-off{
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
  .block2{
    position: relative;
    top: -36px;
    border-radius: 12px;
    &:hover{
      cursor: pointer !important;
    }
    @include button;
    .button-off{
      box-shadow: -1px 3px 2px 1px black;
      border-color: inherit;
      border-radius: 10px 0 0 10px;
      text-transform: uppercase;
      transform: translate3d(0px, 0px, 0px);
      transition: all 0.5s ease;
    }
    .button-on{
      box-shadow: 1px 3px 2px 1px black;
      border-color: inherit;
      border-radius: 0 10px 10px 0;
      text-transform: uppercase;
      transform: translate3d(50px, 0px, 0px);
      transition: all 0.5s ease;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}

@media (min-width: 1400px) {
  .switch {
    .block1 {
      .btn-custom{
        padding: 3px 8px 4px 8px;
        font-size: 13px !important;
      }
    }
    .block2 {
      top: -30px;
      .btn{
        font-size: 13px !important;
      }
      .button-on{
        padding: 4px 10px 4px 10px;
        transform: translate3d(43px, 0px, 0px);
      }
      .button-off{
        padding: 4px 8px 4px 8px;
        transform: translate3d(-1px, 0px, 0px);
      }
    }
  }
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/switch/switch.scss